import React from 'react'

function HistoryDetaulsPopup({ setopenPop, news, isGettingData }) {
    return (
        <div className=" successful_create_transprant_body">
            <div>
                <div className=" delete_activity_transprant_body ">
                    <div
                        dangerouslySetInnerHTML={{ __html: news?.Link }}
                        style={{ width: "50%", height: "60%" }}
                    ></div>
                    <img
                        style={{ position: "relative", top: "-33%" }}
                        src="/images/cross.svg"
                        className="btn-light p-2 rounded-circle"
                        alt=""
                        onClick={(e) => setopenPop(false)}
                    />
                </div>
            </div>
        </div>
    )
}

export default HistoryDetaulsPopup